import React from "react";
import { ssm_getcookie } from "../../../common/utils/ssm_util";
import SSCalendar from "../../../common/components/SSCalendar";
import Spinner from "../../../common/components/Spinner";
import {htmlToText} from "../../../common/utils/utils";
import { getMyPerson } from "../../../common/utils/family";

class MyCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fces: this.g_FCfces(this.props.fces),
      initialDate: "",
    };
  }

  orgid = 0;

  componentWillMount() {
    this.orgid = ssm_getcookie("ssm_orgid");
  }

  g_FCfces(fces) {
    let fcfces = [];
    //console.log(JSON.stringify(fces, null, 2));
    for (let i in fces) {
      let p = getMyPerson(fces[i].PId, this.props.family);
      let name = p.FName + " " + p.LName;

      let f = new Object();
      f.id = fces[i].SCId;
      f.start = new Date(fces[i].Start);
      f.end = new Date(fces[i].End);
      //fces[i].Name = fces[i].Name.replace("<br>", "");
      let titleHtml = fces[i].Name;
      let strippedHtml = htmlToText(titleHtml);
      f.title = fces[i].Desc.replace(/<[^>]+>/g, "");
      if (strippedHtml[1] === undefined && strippedHtml[2] === undefined) {
        f.title = fces[i].Desc.replace(/<[^>]+>/g, "");;
      } else if ( strippedHtml[2] === undefined) {
        f.title = `${fces[i].Desc.replace(/<[^>]+>/g, "")}  ${strippedHtml[1]}`;
      } else {
        f.title = `${fces[i].Desc.replace(/<[^>]+>/g, "")} - ${strippedHtml[1]} - ${strippedHtml[2]}`;
      }
      f.title+=" - "+name;
      fcfces.push(f);
    }
    return fcfces;
  }

  render() {
    return (
      <div>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <SSCalendar fces={this.state.fces} />
          </>
        )}
      </div>
    );
  }
}

export default MyCalendar;